var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9128 8.38013L15.9322 6.36075C17.1961 5.09683 17.1961 3.04356 15.9322 1.77964L11.6223 6.08957V3.23727C11.6223 1.4455 10.1695 -0.00244141 8.38257 -0.00244141V6.08957L6.3632 4.0702C5.09927 2.80628 3.04601 2.80628 1.78208 4.0702L6.09201 8.38013H3.23971C1.44794 8.38013 0 9.83291 0 11.6198H6.08717L4.0678 13.6392C2.80387 14.9031 2.80387 16.9564 4.0678 18.2203L8.37772 13.9104V16.7627C8.37772 18.5545 9.83051 20.0024 11.6174 20.0024V13.9104L13.6368 15.9298C14.9007 17.1937 16.954 17.1937 18.2179 15.9298L13.908 11.6198H16.7603C18.5521 11.6198 20 10.1671 20 8.38013H13.9128Z",
    fill: "#fcfcfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDanceIcon);
export default __webpack_public_path__ + "static/media/whiteDanceIcon.eac4c5b3f0942cc25d060b7df8db42da.svg";
export { ForwardRef as ReactComponent };